import React from 'react';
import classnames from 'classnames';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getCumulativeTableData } from './utils';
import { valueFormat } from '@/pages/intelligence/utils/commonUtils';
import { getCalcMetricTranslateKey } from '@/pages/intelligence/utils/calcMetrics';

import type {
  DataSourceType,
  DataSourceMetricPropsType,
  CumulativeTablePropsType,
} from './types';

import AnnieImg from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import SensorImg from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';

const DATASOURCE_ICON_MAP = {
  appannie: AnnieImg,
  sensortower: SensorImg,
};

const METRIC_TEXT_MAP: { [key: string]: string } = {
  dau: 'dau',
  wau: 'wau',
  mau: 'mau',
  revenue: 'revenue',
  download: 'downloads',
};

const CALCULATE_MODE_TEXT_MAP = {
  sum: 'sum',
  avg: 'avg',
};

const DataSourceMetric: React.FC<DataSourceMetricPropsType> = (props) => {
  const { dataSource, metric, mode, className, style, dateType } = props;

  const { formatMessage } = useIntlExtend();

  const getMetricType = (metric: string) => {
    if (metric == 'dau') {
      switch (dateType) {
        case 'Day':
          return 'dau';
        case 'Week':
          return 'wau';
        case 'Month':
          return 'mau';
        default:
          return metric
      }
    } else {
      return metric
    }
  }

  const dataSourceIcon = DATASOURCE_ICON_MAP[dataSource];
  const modeText = CALCULATE_MODE_TEXT_MAP[mode];
  const metricText = METRIC_TEXT_MAP[getMetricType(metric)];
  const calcMetricLocaleKey = getCalcMetricTranslateKey(metricText, modeText);

  const calcMetricLocaleText = formatMessage({ id: calcMetricLocaleKey });

  return (
    <div
      className={classnames(
        'dbi-table-list-item dbi-metric-table__h3',
        className,
      )}
      style={{ ...style }}
    >
      <img
        src={dataSourceIcon}
        className="dbi-metric-table__table-datasorce"
        alt=""
      />
      <span className="dbi-compare-mobile-text">{calcMetricLocaleText}</span>
    </div>
  );
};

const CumulativeTable: React.FC<CumulativeTablePropsType> = (props) => {
  const { dateType, metric, data, className, style } = props;

  const { mode, games, dataSources } = getCumulativeTableData(data);

  const getCumulativeData = (game: any, dataSource: DataSourceType): string => {
    if (!game || !Array.isArray(game.total)) return '-';
    let result;
    try {
      const target = game.total.find(
        (item: any) => item?.source === dataSource,
      );
      let tempValue = '';
      if (!target) return '-';
      tempValue = target.value;
      // result = tempValue ? formatNum(parseFloat(tempValue)) : '-';
      result = tempValue ? valueFormat(parseFloat(tempValue)) : '-';
    } catch (exception) {
      console.warn(exception);
      result = '-';
    }
    return result as string;
  };

  if (!dataSources?.length || !games?.length) return null;

  return (
    <div
      style={style}
      className={classnames('dbi-flex-table dbi-metric-table', className)}
    >
      {/* 第一列 */}
      <div className=" dbi-table-first-colums dbi-metric-table__table-first-columns">
        {/* 数据源列 */}
        {dataSources?.map((item) => (
          <DataSourceMetric
            key={item}
            dataSource={item}
            metric={metric}
            mode={mode}
            dateType={dateType}
          />
        ))}
      </div>
      {/* 数据列 */}
      {games?.map((game: any) => (
        <div
          key={game?.game_id}
          className="dbi-flex-table__table-content dbi-metric-table__table-content"
        >
          {dataSources?.map((dataSource: DataSourceType) => (
            <div
              key={`${dataSource}_${game?.game_id}`}
              className="dbi-table-list-item"
            >
              <div className="dbi-table-list-item__text">
                {getCumulativeData(game, dataSource)}
              </div>
            </div>
          ))}
        </div>
      ))}

      {/* 最后一列 空的列 */}
      {/* {games?.length < MAXGAMENUM && (
        <div className="dbi-flex-table__table-content">
          {dataSources?.map((dataSource, index: number) => (
            <div key={index} className="dbi-table-list-item"></div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default CumulativeTable;
